export default __webpack_public_path__ + "images/arrows-up-outline-white.dce6332bd85be1db4edfe7523a7268c1.png";